var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.052,
    height: 116,
    viewBox: "0 0 123.052 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Push_notifications-rafiki_1_",
    "data-name": "Push notifications-rafiki (1)",
    transform: "translate(-51.11 -62.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1",
    transform: "translate(59.231 62.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M141.919,91.035c-13.686-10.846-21.8-23.269-38.58-27.864C89.3,59.328,82.281,65.313,78.587,76.244c-9.056,26.938,15.879,56.639,46.126,69.244,28.639,11.941,51.407,2.3,57.95-21.261,2.478-8.9,2.253-24.418-12.407-28.788C159.492,92.225,153.59,100.276,141.919,91.035Z",
    transform: "translate(-76.703 -62.004)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M141.919,91.035c-13.686-10.846-21.8-23.269-38.58-27.864C89.3,59.328,82.281,65.313,78.587,76.244c-9.056,26.938,15.879,56.639,46.126,69.244,28.639,11.941,51.407,2.3,57.95-21.261,2.478-8.9,2.253-24.418-12.407-28.788C159.492,92.225,153.59,100.276,141.919,91.035Z",
    transform: "translate(-76.703 -62.004)",
    fill: "#fff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    transform: "translate(51.11 170.82)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 61.526,
    cy: 3.592,
    rx: 61.526,
    ry: 3.592,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1",
    transform: "translate(104.633 79.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 1.872,
    height: 0.317,
    transform: "translate(49.068 18.373) rotate(-86.3)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 6.153,
    height: 0.317,
    transform: "translate(49.275 15.057) rotate(-86.31)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M265.684,115.74h-37.3a3.852,3.852,0,0,0-3.773,3.551l-4.82,74.413a3.3,3.3,0,0,0,3.322,3.554h37.3a3.859,3.859,0,0,0,3.783-3.554l4.817-74.413a3.3,3.3,0,0,0-3.322-3.551Z",
    transform: "translate(-219.779 -115.739)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M264.5,115.74H228.382a3.852,3.852,0,0,0-3.773,3.551l-4.82,74.413a3.3,3.3,0,0,0,3.322,3.554h36.112a3.859,3.859,0,0,0,3.783-3.554l4.817-74.413a3.3,3.3,0,0,0-3.322-3.551Z",
    transform: "translate(-219.779 -115.739)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M263.3,205.767H223.57a1.085,1.085,0,0,1-1.085-1.155l4.36-67.336a1.085,1.085,0,0,1,1.082-1.015H267.66a1.088,1.088,0,0,1,1.085,1.158l-4.36,67.333a1.085,1.085,0,0,1-1.085,1.015Z",
    transform: "translate(-221.625 -129.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M291.058,126.842H276.616a.536.536,0,0,1-.539-.578h0a.635.635,0,0,1,.612-.574H291.13a.533.533,0,0,1,.539.574h0A.635.635,0,0,1,291.058,126.842Z",
    transform: "translate(-258.211 -122.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M281.675,361.172a1.507,1.507,0,0,1-1.488,1.415,1.333,1.333,0,0,1-1.342-1.415,1.507,1.507,0,0,1,1.488-1.412,1.33,1.33,0,0,1,1.342,1.412Z",
    transform: "translate(-260.1 -282.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M259.843,195H225.918l-2.158,33.287h36.083a3.56,3.56,0,0,0,3.554-3.551V198.564A3.56,3.56,0,0,0,259.843,195Z",
    transform: "translate(-222.497 -169.849)",
    fill: "#15345a",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-1",
    transform: "translate(90.573 98.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 48.684,
    height: 33.291,
    rx: 11.2,
    transform: "translate(3.116 2.679)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M179.8,181.91a.317.317,0,0,1-.222-.092l-.571-.568a.319.319,0,0,1,.451-.451l.568.571a.316.316,0,0,1-.225.539Z",
    transform: "translate(-177.822 -179.615)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M176.59,189.415h-.8a.317.317,0,1,1,0-.635h.8a.317.317,0,1,1,0,.635Z",
    transform: "translate(-175.47 -185.127)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M187.273,178.706a.317.317,0,0,1-.317-.3l-.057-.8a.317.317,0,1,1,.631-.044l.06.8a.317.317,0,0,1-.3.34Z",
    transform: "translate(-183.271 -177.268)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M273.19,279.83l12.766,12.763V279.83Z",
    transform: "translate(-242.181 -247.284)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M245.008,220.345l-.635-2.694a4.874,4.874,0,0,1,0-2.151l.882-3.836a7.524,7.524,0,0,0-3.979-8.349,2.153,2.153,0,0,0,.073-.216,1.816,1.816,0,1,0-3.545-.793,1.367,1.367,0,0,0-.029.225,7.527,7.527,0,0,0-7.162,5.851l-.86,3.84a4.846,4.846,0,0,1-.92,1.939l-1.71,2.174a1.606,1.606,0,0,0,.911,2.558l15.073,3.376a1.6,1.6,0,0,0,1.9-1.923Z",
    transform: "translate(-210.499 -193.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M246.483,264.794a.714.714,0,0,0-.857.822,2.605,2.605,0,0,0,4.706,1.054.714.714,0,0,0-.422-1.107Z",
    transform: "translate(-223.356 -237.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M207.329,217a.47.47,0,0,1-.4-.213,10.18,10.18,0,0,1,2.815-14.118.476.476,0,0,1,.527.793,9.231,9.231,0,0,0-2.539,12.8.476.476,0,0,1-.13.66.482.482,0,0,1-.276.079Z",
    transform: "translate(-195.779 -194.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M214.567,219.974a.476.476,0,0,1-.393-.213,7.759,7.759,0,0,1,2.142-10.754.477.477,0,0,1,.53.793,6.8,6.8,0,0,0-1.882,9.431.476.476,0,0,1-.13.66.489.489,0,0,1-.267.083Z",
    transform: "translate(-201.001 -198.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M221.8,222.986a.47.47,0,0,1-.393-.209,5.325,5.325,0,0,1,1.479-7.391.476.476,0,0,1,.53.79,4.376,4.376,0,0,0-1.209,6.07.474.474,0,0,1-.406.739Z",
    transform: "translate(-206.221 -203.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M297.328,238.853a.476.476,0,0,1-.219-.9,9.231,9.231,0,0,0,3.967-12.433.476.476,0,1,1,.844-.435,10.18,10.18,0,0,1-4.385,13.715A.5.5,0,0,1,297.328,238.853Z",
    transform: "translate(-258.335 -209.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M293.818,239.155a.476.476,0,0,1-.219-.9,6.8,6.8,0,0,0,2.923-9.164.477.477,0,0,1,.847-.438,7.749,7.749,0,0,1-3.332,10.446A.457.457,0,0,1,293.818,239.155Z",
    transform: "translate(-255.939 -212.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M290.316,239.4a.479.479,0,0,1-.219-.9,4.369,4.369,0,0,0,1.882-5.893.477.477,0,1,1,.847-.438,5.334,5.334,0,0,1-2.3,7.178A.485.485,0,0,1,290.316,239.4Z",
    transform: "translate(-253.551 -214.569)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(63.592 69.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M196.5,125.85h-2.424a.267.267,0,0,0-.257.228l-.508,4.836a.206.206,0,0,0,.206.232h2.424a.267.267,0,0,0,.257-.232l.508-4.836a.2.2,0,0,0-.206-.228Z",
    transform: "translate(-160.665 -113.1)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M196.277,125.848h-2.205a.267.267,0,0,0-.257.228l-.508,4.836a.206.206,0,0,0,.206.232h2.221a.263.263,0,0,0,.254-.232l.508-4.836a.2.2,0,0,0-.219-.228Z",
    transform: "translate(-160.665 -113.097)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M163.292,406.315a1.037,1.037,0,0,0,.746-.194.235.235,0,0,0,0-.267.337.337,0,0,0-.2-.143c-.432-.117-1.307.4-1.345.419a.057.057,0,0,0-.025.06.064.064,0,0,0,.051.051A4.621,4.621,0,0,0,163.292,406.315Zm.387-.5a.455.455,0,0,1,.117,0,.209.209,0,0,1,.124.086c.044.076.032.114,0,.133-.111.168-.762.171-1.241.1a2.6,2.6,0,0,1,1-.324Z",
    transform: "translate(-139.612 -304.143)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M162.473,404.929h.025c.317-.14.895-.695.835-.987,0-.067-.067-.152-.235-.168a.441.441,0,0,0-.333.1,1.651,1.651,0,0,0-.355.99.067.067,0,0,0,.029.057A.064.064,0,0,0,162.473,404.929Zm.584-1.041h.035c.111,0,.121.054.121.067.038.174-.362.612-.67.8a1.383,1.383,0,0,1,.317-.793A.317.317,0,0,1,163.057,403.889Z",
    transform: "translate(-139.574 -302.83)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 2.57,
    height: 5.95,
    transform: "translate(20.069 96.089)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M94.95,385.865l2.567.279,1.672-5.775-2.567-.279Z",
    transform: "translate(-93.521 -286.663)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M105.086,399.863a1.019,1.019,0,0,0,.777,0,.225.225,0,0,0,.051-.26.317.317,0,0,0-.159-.184c-.4-.219-1.38.057-1.422.067a.06.06,0,0,0-.044.054.067.067,0,0,0,.038.06,4.715,4.715,0,0,0,.758.263Zm.5-.381a.506.506,0,0,1,.111.041.2.2,0,0,1,.1.111.218.218,0,0,1,0,.136c-.152.13-.79-.025-1.244-.209a2.672,2.672,0,0,1,1.031-.076Z",
    transform: "translate(-99.897 -299.801)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M104.33,398.064h.025c.317-.06,1.047-.447,1.06-.739,0-.07-.025-.165-.187-.222a.454.454,0,0,0-.352.019c-.374.181-.584.835-.593.86a.06.06,0,0,0,0,.06A.054.054,0,0,0,104.33,398.064Zm.825-.854h.038c.1.038.1.082.1.1,0,.178-.508.5-.857.6a1.349,1.349,0,0,1,.5-.682.317.317,0,0,1,.222-.016Z",
    transform: "translate(-99.886 -298.259)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M94.578,396.666l-2.808-.806a.216.216,0,0,0-.254.108l-1.034,2.053a.39.39,0,0,0,.257.543c.984.263,1.476.346,2.71.7.758.219,2.3.746,3.354,1.047s1.437-.685,1.031-.9a6.794,6.794,0,0,1-2.888-2.472A.656.656,0,0,0,94.578,396.666Z",
    transform: "translate(-90.445 -297.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M154.323,406.29h-2.805a.209.209,0,0,0-.209.178l-.409,2.269a.4.4,0,0,0,.39.46c1.012-.019,2.472-.079,3.744-.079,1.488,0,2.3.083,4.046.083,1.054,0,1.3-1.066.854-1.165-2.028-.438-3.2-.486-4.982-1.558A1.269,1.269,0,0,0,154.323,406.29Z",
    transform: "translate(-131.712 -304.549)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 2.57,
    height: 3.069,
    transform: "translate(20.069 96.089)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M98.363,380.1l2.567.276-.93,3.2-2.5-.5Z",
    transform: "translate(-95.261 -286.67)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M112.124,202s-1.418,19.4-2.688,26.757c-1.4,8.057-9.542,32.726-9.542,32.726l-4.665-.854s5.88-23.165,6.531-31.142c.708-8.657,1.558-26.5,1.558-26.5Z",
    transform: "translate(-93.712 -165.086)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M138.912,226.6c.254-1.066.838.276,1.517,2.6-.514,5.756-1.184,12.423-1.825,16.1-.143.822-.359,1.818-.635,2.948C138.214,240.037,138.224,229.486,138.912,226.6Z",
    transform: "translate(-122.889 -181.627)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M144.413,200.34s1.863,19.5,1.926,27.338c.067,8.152-1.612,34.839-1.612,34.839h-4.357s-1.307-26.211-1.85-34.217c-.593-8.726-3.091-26.973-3.091-26.973Z",
    transform: "translate(-121.155 -163.952)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M100.132,382.711c.019,0-.733,1.691-.733,1.691l-5.249-.952.317-1.571Z",
    transform: "translate(-92.974 -287.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M154.917,390.81c.019,0-.168,1.809-.168,1.809h-5.293l-.216-1.612Z",
    transform: "translate(-130.583 -293.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M105.435,139.668c-.349.676-.733,1.387-1.082,2.088l-1.066,2.113c-.346.7-.685,1.412-1.012,2.12s-.635,1.412-.9,2.117l-.025-1.111a13.751,13.751,0,0,0,.666,1.669c.124.279.282.546.419.822s.317.539.479.8a18.356,18.356,0,0,0,1.092,1.558c.2.251.393.508.6.749s.438.492.635.7l.063.07a.914.914,0,0,1-1.123,1.412,10.455,10.455,0,0,1-.952-.606,11,11,0,0,1-.882-.66,15.164,15.164,0,0,1-1.606-1.526,13.9,13.9,0,0,1-1.38-1.783,13.644,13.644,0,0,1-1.1-2.025,1.368,1.368,0,0,1-.067-.952l.044-.149c.241-.828.511-1.631.809-2.418s.616-1.558.952-2.316.689-1.507,1.06-2.247.746-1.463,1.174-2.2a1.84,1.84,0,1,1,3.23,1.764Z",
    transform: "translate(-95.701 -120.663)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M109.049,135.5c.127,2.421-2.621,6.867-2.621,6.867l-5.658-2.827a16.656,16.656,0,0,1,3.135-5.468C106.9,130.762,108.932,133.275,109.049,135.5Z",
    transform: "translate(-97.494 -117.621)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M114.78,188.911l1.139,1.9,2.37-1.517a3.84,3.84,0,0,0-1.844-1.66.793.793,0,0,0-.952.4Z",
    transform: "translate(-107.058 -155.256)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M119.319,195.313l1.1-.206a.714.714,0,0,0,.571-.838L120.74,193l-2.37,1.517.159.384A.711.711,0,0,0,119.319,195.313Z",
    transform: "translate(-109.509 -158.941)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M142.421,102.806c.022.206.152.368.286.355s.222-.187.2-.393-.152-.368-.286-.359S142.4,102.6,142.421,102.806Z",
    transform: "translate(-125.925 -97.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M142.85,104.82a7.983,7.983,0,0,0,1.19,1.7,1.139,1.139,0,0,1-.952.263Z",
    transform: "translate(-126.221 -98.743)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M139.393,99.09a.111.111,0,0,0,.092-.029.92.92,0,0,1,.835-.225.114.114,0,0,0,.146-.083.127.127,0,0,0-.086-.152,1.171,1.171,0,0,0-1.06.273.121.121,0,0,0,0,.175A.108.108,0,0,0,139.393,99.09Z",
    transform: "translate(-123.785 -94.476)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M122.27,110.9c.606,1.837,1.412,5.223.263,6.581,0,0,.755,1.85,4.233,1.555,3.83-.317,1.587-2.047,1.587-2.047-2.151-.317-2.3-1.869-2.12-3.351Z",
    transform: "translate(-112.171 -102.894)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M119.546,129.542c-.359-.574-.758-1.231-.079-1.476a20.4,20.4,0,0,1,6.426-.34c1.491.368,1.187,1.587,1.187,1.587Z",
    transform: "translate(-110.006 -114.285)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M152.529,135.156c.546.5,1.136,1.057,1.723,1.564s1.18,1.028,1.777,1.529,1.206.974,1.818,1.434,1.234.879,1.856,1.269l-1.269-.121a4.738,4.738,0,0,0,1.476-.682,9.674,9.674,0,0,0,1.453-1.247,16.753,16.753,0,0,0,1.336-1.545c.213-.276.425-.555.635-.844s.4-.593.574-.86l.035-.051a.917.917,0,0,1,1.647.762c-.121.413-.248.765-.393,1.133s-.3.73-.47,1.085a14.661,14.661,0,0,1-1.215,2.078,10.885,10.885,0,0,1-1.682,1.9,7.419,7.419,0,0,1-2.4,1.434,1.517,1.517,0,0,1-1.168-.067l-.1-.054a22.87,22.87,0,0,1-2.291-1.295c-.72-.466-1.418-.952-2.091-1.472s-1.323-1.047-1.958-1.587-1.244-1.1-1.863-1.736a1.84,1.84,0,0,1,2.554-2.646Z",
    transform: "translate(-130.724 -119.125)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M124.507,130.365s3.2,3.1,3.57,22.3a40.221,40.221,0,0,1-13.839,1.215,94.174,94.174,0,0,0-2.894-19.579,2.783,2.783,0,0,1,2.155-3.491c.486-.1,1-.181,1.5-.248a50.585,50.585,0,0,1,5.82-.492,25.767,25.767,0,0,1,3.684.3Z",
    transform: "translate(-104.641 -115.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M145.15,134.252c.317,2.4,4.443,7.019,4.443,7.019l4.9-5.077a40.175,40.175,0,0,0-4.7-4.217C146.2,129.3,144.864,132.025,145.15,134.252Z",
    transform: "translate(-127.765 -116.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M195.884,135.1l1.637-1.5-1.961-2.015a3.84,3.84,0,0,0-1.269,2.139.793.793,0,0,0,.6.85Z",
    transform: "translate(-161.336 -117.012)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M200.837,131.29l-.422-1.038a.717.717,0,0,0-.952-.39l-1.2.5,1.961,2.015.343-.232a.714.714,0,0,0,.273-.86Z",
    transform: "translate(-164.048 -115.798)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M120.6,95.33c.46,2.539.6,4.043,2.028,5.252a3.257,3.257,0,0,0,5.395-2.19c.267-2.336-.53-6.1-3.113-6.915A3.307,3.307,0,0,0,120.6,95.33Z",
    transform: "translate(-110.987 -89.513)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M118.876,92.4c.892.2,1.587-.828,1.682-1.12A2.2,2.2,0,0,1,119.2,90.9c.476.041.936-.546.993-.771a1.98,1.98,0,0,1-1.247-.809,1.632,1.632,0,0,0,.85-2.589c-.847-1.215-4.389-.2-4.887-1.063-.743.432-.083,1.006-.083,1.006s-5.011.952-2.7,2.884c-1.695.152-1.933,2.155-.52,3.173s1.485,1.691.923,1.609c.225.432,1.231.489,1.288.07a2.258,2.258,0,0,0,2.5,1.875C117.9,96.094,119.451,93.882,118.876,92.4Z",
    transform: "translate(-104.262 -85.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M112.25,94.631c-1.193.165-1.736-.508-1.437-1.1C109.333,94.285,110.949,95.954,112.25,94.631Z",
    transform: "translate(-103.947 -91.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M132.492,103.429a2.793,2.793,0,0,0,1.041,1.307c.635.419,1.209,0,1.1-.635-.1-.584-.546-1.507-1.206-1.672a.755.755,0,0,0-.936,1Z",
    transform: "translate(-119.113 -97.085)",
    fill: "#ff8b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1",
    transform: "translate(154.232 142.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M381.967,362.141c-2.348-5.54-3.3-12.058-.609-11.789,2.758.267,2.434,10.091,2.881,11.17A3.5,3.5,0,0,1,381.967,362.141Z",
    transform: "translate(-378.573 -338.916)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M385.616,354.39c-.578,2.113-1.19,5.379-1.656,8.146.267.793.568,1.587.895,2.367a3.515,3.515,0,0,0,2.275-.619C386.775,363.434,386.9,357.138,385.616,354.39Z",
    transform: "translate(-381.461 -341.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M388.9,336.539c-.736-11.773,1.269-22.686,6.55-22.194,4.531.425-2.075,20.245-1.948,22.53A6.855,6.855,0,0,1,388.9,336.539Z",
    transform: "translate(-384.735 -314.33)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M400,350.325c.828-8.463,5.293-18.338,7.21-15.038,2.434,4.189-3.808,14.165-3.976,15.806A4.944,4.944,0,0,1,400,350.325Z",
    transform: "translate(-392.411 -328.192)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M395.644,320.064a.83.83,0,0,1-.8-.895c.038-.533.476-1.063.882-1.069.2,0,.527.1.609.835l-.317.038c-.038-.349-.143-.555-.282-.555h0c-.216,0-.546.393-.571.774-.022.317.155.5.533.558Z",
    transform: "translate(-388.889 -316.904)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M413.043,327.186a1.2,1.2,0,0,1-.635-.244l.171-.263c.3.19.524.241.612.133a.884.884,0,0,0-.235-.936c-.222-.213-.482-.2-.771.057l-.206-.241a.828.828,0,0,1,1.2-.044,1.143,1.143,0,0,1,.263,1.361.47.47,0,0,1-.4.178Z",
    transform: "translate(-400.589 -321.896)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M388.96,341.908a.79.79,0,0,1-.831-.635,1.144,1.144,0,0,1,.514-1.288c.181-.06.53-.067.835.609l-.292.133c-.143-.317-.317-.489-.441-.441a.9.9,0,0,0-.317.911c.073.317.317.425.679.368l.048.317A1.139,1.139,0,0,1,388.96,341.908Z",
    transform: "translate(-384.284 -331.827)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M378.371,362.723a.768.768,0,0,1-.727-.473,1.151,1.151,0,0,1,.26-1.365c.168-.1.511-.165.936.444l-.26.181c-.2-.289-.4-.419-.517-.349a.877.877,0,0,0-.13.952c.13.282.378.359.736.232l.1.3A1.179,1.179,0,0,1,378.371,362.723Z",
    transform: "translate(-377.074 -346.069)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M396.656,332.7a.165.165,0,0,1-.092-.029.933.933,0,0,1-.419-1.152,1.069,1.069,0,0,1,1.107-.635c.2.035.657.209.689,1.054a.159.159,0,0,1-.317,0c-.019-.441-.168-.708-.428-.755a.762.762,0,0,0-.758.454c-.114.27,0,.543.317.768a.159.159,0,0,1-.092.289Z",
    transform: "translate(-389.737 -325.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M407.719,359.609a.152.152,0,0,1-.152-.127.155.155,0,0,1,.121-.187c.432-.089.67-.282.676-.546a.765.765,0,0,0-.574-.673c-.286-.07-.539.086-.708.435a.159.159,0,1,1-.286-.14.952.952,0,0,1,1.066-.606,1.079,1.079,0,0,1,.819.987c0,.2-.1.682-.927.854Z",
    transform: "translate(-397.039 -343.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M422.291,351.089c-.184,0-.428-.108-.7-.517l.263-.178c.2.292.384.425.508.359a.848.848,0,0,0,.149-.952c-.121-.282-.368-.365-.73-.248l-.1-.3a.837.837,0,0,1,1.12.425,1.141,1.141,0,0,1-.289,1.355A.441.441,0,0,1,422.291,351.089Z",
    transform: "translate(-407.15 -338.126)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M390.28,381.971a7.054,7.054,0,0,0-1.71-4.614.46.46,0,0,0,.393-.451.47.47,0,0,0-.47-.466H377.869a.463.463,0,0,0-.07.92,7.083,7.083,0,0,0,2.066,10.887.514.514,0,0,0,.238.971h6.153a.515.515,0,0,0,.238-.971A7.1,7.1,0,0,0,390.28,381.971Z",
    transform: "translate(-376.084 -356.731)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataNotification);
export default __webpack_public_path__ + "static/media/nodataNotification.6b077413bc13a5fd2c59e80542546a15.svg";
export { ForwardRef as ReactComponent };